import type { MenuProps } from "@mui/material";

export const APP_TEXT_COLOR = "rgb(var(--text))";
export const APP_BG_COLOR = "rgb(var(--appBg))";
export const APP_CARD_BG_COLOR = "rgb(var(--cardBg))";

export const appThemedSelectSx = {
  color: APP_TEXT_COLOR,
  backgroundColor: APP_BG_COLOR,
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: `${APP_TEXT_COLOR} !important`,
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: `${APP_TEXT_COLOR} !important`,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: `${APP_TEXT_COLOR} !important`,
  },
  "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: `${APP_TEXT_COLOR} !important`,
    opacity: 0.5,
  },
  "& .MuiSelect-select": {
    color: `${APP_TEXT_COLOR} !important`,
    WebkitTextFillColor: `${APP_TEXT_COLOR} !important`,
    backgroundColor: "transparent",
  },
  "&.Mui-disabled .MuiSelect-select": {
    color: `${APP_TEXT_COLOR} !important`,
    WebkitTextFillColor: `${APP_TEXT_COLOR} !important`,
    opacity: 1,
  },
  "& .MuiSvgIcon-root": {
    color: APP_TEXT_COLOR,
  },
};

export const appThemedSelectMenuProps = {
  slotProps: {
    paper: {
      className: "bg-appBg text-appText",
      sx: {
        color: APP_TEXT_COLOR,
        backgroundColor: APP_BG_COLOR,
        "& .MuiMenuItem-root": {
          color: `${APP_TEXT_COLOR} !important`,
          backgroundColor: APP_BG_COLOR,
        },
        "& .MuiMenuItem-root.Mui-selected": {
          color: `${APP_TEXT_COLOR} !important`,
          backgroundColor: `${APP_BG_COLOR} !important`,
        },
        "& .MuiMenuItem-root.Mui-selected:hover": {
          color: `${APP_TEXT_COLOR} !important`,
          backgroundColor: `${APP_BG_COLOR} !important`,
        },
        "& .MuiMenuItem-root:hover": {
          color: `${APP_TEXT_COLOR} !important`,
          backgroundColor: APP_BG_COLOR,
        },
      },
    },
  },
} as Partial<MenuProps>;
